export default 'marketingApp';
